import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delayMs: { default: 3000, type: Number },
    durationMs: { default: 500, type: Number },
  }

  connect() {
    this.fadeIn(this.fadeOut)
  }

  fadeIn = (callback) => {
    this.element.classList.remove("hidden")

    this.element.classList.add(
      `duration-${this.durationMsValue}`,
      "opacity-0",
      "transition-opacity"
    )

    requestAnimationFrame(() => {
      const onTransitionEnd = () => {
        this.element.removeEventListener("transitionend", onTransitionEnd)
        this.element.style.transitionDelay = `${this.delayMsValue}ms`
        callback()
      }

      this.element.addEventListener("transitionend", onTransitionEnd)

      this.element.classList.replace("opacity-0", "opacity-100")
    })
  }

  fadeOut = () => {
    const onTransitionEnd = () => {
      this.element.removeEventListener("transitionend", onTransitionEnd)
      this.element.remove()
    }

    this.element.addEventListener("transitionend", onTransitionEnd)

    requestAnimationFrame(() => {
      this.element.classList.replace("opacity-100", "opacity-0")
    })
  }
}
